import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}
& > button{
  margin-top: 20px;
  margin-bottom: 20px;
}

`